import React, { Component } from 'react'
import { connect } from "react-redux";
import { Helmet } from 'react-helmet-async';
import IconButton from '@mui/material/IconButton';
import MatButton from '@mui/material/Button';
import MUIDataTable from "mui-datatables";
import "react-datepicker/dist/react-datepicker.css";

// intl messages
import IntlMessages from 'Util/IntlMessages';
// page title bar
import PageTitleBar from 'Components/PageTitleBar/PageTitleBar';
// app config
import AppConfig from 'Constants/AppConfig';

import Createvisual from './visualcomponent/createvisual';

import { 
   allMSKVisualisation,
   mskVisualisationDetails
} from 'Actions';

// rct card box
import RctCollapsibleCard from 'Components/RctCollapsibleCard/RctCollapsibleCard';
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';

class mskvisualisation extends Component {
   
    constructor(props) {
      
        super(props);
        this.state = {
            
            viewdiv:true,
            repeatHeaders:true,
            succdiv:false,
            errordiv:false,
            visualdiv:false,

        };      
         
        this.selectorRef = React.createRef(null);
         this.onBackSection = this.onBackSection.bind(this);  
         this.backSection = this.backSection.bind(this);  
         this.backMainSection = this.backMainSection.bind(this);  
    }

    UNSAFE_componentWillMount() {
        var stdrole=localStorage.getItem('stdrole');
        if(stdrole==1){
            var studid=localStorage.getItem('user_id');
        }else{
            var studid='';
        }
        this.props.allMSKVisualisation(studid);
	}

    onBackSection() {
		this.setState({ adddiv:false,
         editdiv:false,
         viewdiv:true });
	}

    
    addHandleReport(assmntval){
        var student = assmntval.mv_studentID;
        var selyear = assmntval.mv_year;
        var commaSep = assmntval.mv_quaters;
        var id= assmntval.mvID;
       
        this.props.mskVisualisationDetails(student, selyear, commaSep, id).then((data) => {   
                
            if(data.status==1){
                this.setState({ 
                    viewdiv:false,
                    visualdiv:true,
                 });
            }
        });
        
        
    }

   
    backSection(){
        this.setState({    
               
            viewdiv:true,
            visualdiv:false
         });    
    }

    backMainSection(){
        this.setState({                      
            viewdiv:true,
            visualdiv:false
         });    
    }

    render() {
      const { match, mskvisualisationlist, loading } = this.props;
    const options = {
        filterType: 'dropdown',
        rowsPerPage: 50,
        rowsPerPageOptions: [50, 100, 150],
        selectableRowsHideCheckboxes: true,
    };

    const columns = [
        { name: "no", label: "No" },
        { name: "name", label: "Name" },
        { name: "year", label: "Year" },
        { name: "assessment", label: "Asse" },
        { name: "date", label: "Date" },
        { name: "action", label: "Action" },
        { name: "delete", label: "Delete" }
    ];

    const tabledata=mskvisualisationlist.map((assmntval,idx) => {  

            const ebtn=<MatButton variant="contained" className="btn-icon btn-twitter mr-15 mb-10 text-white" onClick={ ()=>this.addHandleReport(assmntval)}> <i className="zmdi zmdi-file-text"></i> View</MatButton>;
            const dbtn=<IconButton className="text-danger" aria-label="Delete" onClick={ ()=>this.deleteAssessment(assmntval.mvID)}><DeleteOutlineOutlinedIcon/></IconButton>;

            return {
                no:idx+1,
                name: assmntval.student,
                year: assmntval.mv_year,
                assessment: assmntval.mv_quaters,
                date: assmntval.crdate,
                action: ebtn
            }
    });   
       
      
        const styles = {
            table: {
                border: "2px solid rgb(0, 0, 0)",
                borderColor:"rgb(0 0 0 / 49%)",
                borderStyle:"solid"
            },
            tabletrtd: {
                borderWidth: "1px",
                borderStyle: "solid",
                borderColor: "black",
                borderCollapase: "collapse",
                borderSpacing: "0px"
            },
            errmessage:{
                textAlign:"center",
                color:"red"
            }
        };
     
    
       return (
          
                <div className="row">  
            

                {this.state.viewdiv && 
                    <div className="col-sm-12 col-md-12">
                        <div className="col-md-10" style={{margin:"0 auto"}}>
                        <RctCollapsibleCard heading="Report List" fullBlock>
                            <MUIDataTable
                                data={tabledata}
                                columns={columns}
                                options={options} 
                            />   
                        </RctCollapsibleCard>
                        </div>
                    </div>  
                }               

                {this.state.visualdiv &&
                 
                    <div className="col-sm-12 col-md-8" style={{margin:"0 auto"}}>
                             <Createvisual onClick={this.backSection} data={this.state} />   
                    </div>
                   
                }

               
                {this.state.errordiv &&
                    <div className="col-sm-12 col-md-8">
                        <h4 style={styles.errmessage}> No Record Found </h4>
                    </div>
                }
                </div>             
             
          
       )
    }
 }


const mapStateToProps = ({mostlyused, mskvisualisation}) => {                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                        
	const { mskvisualisationlist, mskyears } = mskvisualisation;
    const { studentlists, loading } = mostlyused;
	return {studentlists, mskvisualisationlist,  mskyears, loading};
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           
}

export default connect(mapStateToProps, {
    allMSKVisualisation,
    mskVisualisationDetails
})(mskvisualisation); 